export const getConfig = /* GraphQL */ `
  query GetConfig($label: String!) {
    getConfig(label: $label) {
      label
      value
    }
  }
`;

export const getStore = /* GraphQL */ `
  query GetStore($id: ID!) {
    getStore(id: $id) {
      id
      createdAt
      status
      slug
      hostname
      code
      name
      body
      logo {
        type
        key
        bucket
        name
      }
      tags
    }
  }
`;

export const listStoreBySlug = /* GraphQL */ `
  query ListStoresBySlug($slug: String) {
    storeBySlug(slug: $slug) {
      items {
        slug
      }
    }
  }
`;

export const listProducts = /* GraphQL */ `
  query ListProducts($storeID: ID, $nextToken: String) {
    productsByStore(storeID: $storeID, nextToken: $nextToken) {
      items {
        id
        storeID
        createdAt
        updatedAt
        status
        name
        slug
        price
        body
        tags
        medias {
          type
          key
          bucket
          name
          extension
          size
        }
      }
      nextToken
    }
  }
`;

export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      storeID
      createdAt
      updatedAt
      status
      name
      slug
      price
      body
      tags
      medias {
        type
        key
        bucket
        name
        extension
        size
      }
    }
  }
`;

export const getProspect = /* GraphQL */ `
  query GetProspect($email: String!) {
    getProspect(email: $email) {
      email
      firstname
      lastname
      status
    }
  }
`;

export const getClient = /* GraphQL */ `
  query getClient($email: String!) {
    getClient(email: $email) {
      email
      firstname
      lastname
      phone
      address
      address2
    }
  }
`;

export const listFAQ = /* GraphQL */ `
  query ListFAQs($storeID: ID, $productID: ModelIDKeyConditionInput) {
    faqsByStoreProduct(storeID: $storeID, productID: $productID) {
      items {
        id
        storeID
        productID
        question
        answer
      }
    }
  }
`;
